var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0 background-white",
          staticStyle: { "z-index": "10" },
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus
          },
          attrs: { role: "main" }
        },
        [
          _c("div", { staticClass: "required" }),
          _vm._v(" "),
          _c("div", { staticClass: "container page-wrap" }, [
            _c("div", { staticClass: "row no-gutters mx-0 my-3" }, [
              _c("div", { staticClass: "col-9" }, [
                _vm.complete && _vm.nocarrierAlert
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-warning alert-dismissible fade show b-alert-warning",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("div", { staticClass: "text-div" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "28",
                                height: "28",
                                viewBox: "0 0 28 28",
                                fill: "none"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M28 14C28 21.7337 21.7314 28 14 28C6.26856 28 0 21.7337 0 14C0 6.27082 6.26856 0 14 0C21.7314 0 28 6.27082 28 14ZM14 16.8226C12.5658 16.8226 11.4032 17.9852 11.4032 19.4194C11.4032 20.8535 12.5658 22.0161 14 22.0161C15.4342 22.0161 16.5968 20.8535 16.5968 19.4194C16.5968 17.9852 15.4342 16.8226 14 16.8226ZM11.5346 7.48853L11.9533 15.166C11.9729 15.5252 12.27 15.8065 12.6298 15.8065H15.3703C15.73 15.8065 16.0271 15.5252 16.0467 15.166L16.4654 7.48853C16.4866 7.10049 16.1776 6.77419 15.789 6.77419H12.2109C11.8223 6.77419 11.5134 7.10049 11.5346 7.48853Z",
                                  fill: "#EAAA00"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "ml-3",
                            domProps: {
                              innerHTML: _vm._s(_vm.nocarrierAlertMsg)
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.blurbs.formtop && _vm.blurbs.formtop.visible
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center mx-auto mt-3 mb-1"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-primary my-0 py-2 w-100",
                            attrs: { role: "note" }
                          },
                          [
                            _c("div", { staticClass: "row no-gutters" }, [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "col d-inline-block my-auto smaller-font-content",
                                domProps: {
                                  innerHTML: _vm._s(_vm.blurbs.formtop.content)
                                }
                              })
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              !(_vm.isHomeBound && _vm.isAutoBound) &&
              _vm.appointedCarrierStatus
                ? _c("div", { staticClass: "col-3" }, [
                    _c(
                      "div",
                      { staticClass: "smaller-text-secondary text-right" },
                      [
                        _vm._v(
                          "Last updated " + _vm._s(_vm.lastRC1DateTimeString)
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary float-right refreshButton mb-2",
                        attrs: {
                          type: "button",
                          tabindex: "0",
                          role: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.refreshRates()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas" }, [_vm._v("")]),
                        _vm._v(" Refresh Rates")
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row no-gutters mx-0 my-3",
                attrs: { id: "carrier-results" }
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "col-12 px-0" }, [
                        _c(
                          "div",
                          {
                            staticClass: "container",
                            attrs: { id: "results-table" }
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.complete &&
                                      _vm.carrierSuccessArray.length > 0,
                                    expression:
                                      "complete && carrierSuccessArray.length > 0"
                                  }
                                ],
                                staticClass: "row"
                              },
                              [
                                _c("div", { staticClass: "col-9" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row smaller-font-content font-weight-bold border-bottom border-bottom-carriers bg-white",
                                      attrs: { id: "results-head" }
                                    },
                                    [
                                      _vm.flowType == "bundle"
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "col-3 col-head my-auto",
                                              class: {
                                                selected: _vm.sortKey === "home"
                                              },
                                              attrs: {
                                                href: "JavaScript:void(0);"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.sort("home")
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Home\n                          "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flowType == "cabundle"
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "col-3 col-head my-auto",
                                              class: {
                                                selected:
                                                  _vm.sortKey === "condo"
                                              },
                                              attrs: {
                                                href: "JavaScript:void(0);"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.sort("condo")
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Condo\n                          "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flowType == "rabundle"
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "col-3 col-head my-auto",
                                              class: {
                                                selected:
                                                  _vm.sortKey === "renters"
                                              },
                                              attrs: {
                                                href: "JavaScript:void(0);"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.sort("renters")
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Renters\n                          "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "col-3 col-head my-auto",
                                          class: {
                                            selected: _vm.sortKey === "auto"
                                          },
                                          attrs: {
                                            href: "JavaScript:void(0);"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.sort("auto")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Auto\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "col-3 col-head my-auto",
                                          class: {
                                            selected: _vm.sortKey === "all"
                                          },
                                          attrs: {
                                            href: "JavaScript:void(0);"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.sort("all")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            All Quotes\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-3" })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-3 position-relative export-dropdown-col p-0"
                                  },
                                  [
                                    _c("input-select", {
                                      ref: _vm.exportDropdown.field_name,
                                      attrs: {
                                        fieldData: _vm.exportDropdown,
                                        exportPDF: _vm.exportPDF
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.carrierCount > 0 &&
                                      _vm.showProgressBar === true,
                                    expression:
                                      "carrierCount > 0 && showProgressBar === true"
                                  }
                                ],
                                staticClass:
                                  "row progress shadow-sm rounded-0 mb-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "progress_bar",
                                    staticClass:
                                      "progress-bar progress-bar-striped progress-bar-animated bg-warning text-dark text-center bold px-3",
                                    staticStyle: { width: "0%" },
                                    attrs: {
                                      role: "progressbar",
                                      "aria-valuemin": "0",
                                      "aria-valuemax": "100"
                                    }
                                  },
                                  [_vm._v("Retrieving Quotes...")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.carrierSuccessArray, function(
                              carrier,
                              cKey
                            ) {
                              return _vm.sortKey === "all" ||
                                _vm.sortKey === carrier.carrierType
                                ? _c("carrier-success", {
                                    key: cKey + "_carKey",
                                    attrs: { carrier: carrier, carCount: cKey }
                                  })
                                : _vm._e()
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.carrierErrorArray.length > 0 &&
                                  _vm.complete,
                                expression:
                                  "carrierErrorArray.length > 0 && complete"
                              }
                            ],
                            staticClass: "col-12",
                            attrs: { id: "knockout-wrap" }
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm._l(_vm.carrierErrorArray, function(
                              carrier,
                              fKey
                            ) {
                              return _c("carrier-failure", {
                                key: fKey + "_failKey",
                                attrs: { carrier: carrier, carCountFail: fKey }
                              })
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.carrierSuccessArray.length === 0 &&
                        _vm.carrierErrorArray.length === 0 &&
                        _vm.complete
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 text-center text-secondary my-4"
                              },
                              [
                                _c("h3", [_vm._v("No Carriers Found.")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "There are no returned carrier matches. This could be caused by a failed system response."
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            !_vm.appointedCarrierStatus
              ? _c("div", { staticClass: "row col-12" }, [
                  _c(
                    "div",
                    { staticClass: "text-center col-md-12 appt-error-msg" },
                    [
                      _vm._v(
                        "You're not appointed by any carriers in this state."
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.selectedHomeCarrier || _vm.selectedAutoCarrier
        ? _c("div", { staticClass: "blank-space" })
        : _vm._e(),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.isHomeBound && _vm.isAutoBound
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e(),
      _vm._v(" "),
      (_vm.selectedHomeCarrier || _vm.selectedAutoCarrier) &&
      !(_vm.isHomeBound && _vm.isAutoBound)
        ? _c(
            "div",
            {
              class: {
                "selected-carrier-bottom-container": true,
                "margin-25": _vm.quotePanelStatus
              }
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row no-gutters mx-0 my-3 d-flex align-items-center px-3"
                  },
                  [
                    _vm.sameCarrierBundleDiscount
                      ? _c(
                          "div",
                          {
                            staticClass: "col-12 same-carrier-bundle-discount"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "alert alert-primary",
                                attrs: { role: "alert" }
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "fas circle-icon-info mr-2" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "32",
                                          height: "33",
                                          viewBox: "0 0 32 33",
                                          fill: "none"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M16.0003 29.8979C23.3337 29.8979 29.3337 23.8979 29.3337 16.5645C29.3337 9.2312 23.3337 3.2312 16.0003 3.2312C8.66699 3.2312 2.66699 9.2312 2.66699 16.5645C2.66699 23.8979 8.66699 29.8979 16.0003 29.8979ZM14.667 9.89787H17.3337V12.5645H14.667V9.89787ZM18.667 23.2312H13.3337V20.5645H14.667V17.8979H13.3337V15.2312H17.3337V20.5645H18.667V23.2312Z",
                                            fill: "#003366"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _c("strong", [_vm._v("Potential Savings:")]),
                                _vm._v(
                                  " The biggest discounts are most likely when you bundle "
                                ),
                                _vm.flowType == "bundle"
                                  ? _c("span", [_vm._v("home")])
                                  : _vm._e(),
                                _vm.flowType == "cabundle"
                                  ? _c("span", [_vm._v("condo")])
                                  : _vm._e(),
                                _vm.flowType == "rabundle"
                                  ? _c("span", [_vm._v("renters")])
                                  : _vm._e(),
                                _vm._v(
                                  " and auto with the same carrier.\n        "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-3 summary-col" }, [
                      _c("p", [_vm._v("Insurance Summary")]),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.policyTerm,
                                expression: "policyTerm"
                              }
                            ],
                            staticClass: "form-select select-dropbox",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.policyTerm = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.termArr, function(termData, tkey) {
                            return _c(
                              "option",
                              { key: tkey, domProps: { value: tkey } },
                              [_vm._v(" " + _vm._s(termData))]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 text-center",
                        class: { "disabled bound-carrier": _vm.isHomeBound }
                      },
                      [
                        !_vm.selectedHomeCarrier
                          ? _c("div", { staticClass: "select-auto-carrier" }, [
                              _vm._v("Select "),
                              _vm.flowType == "bundle"
                                ? _c("span", [_vm._v("Home")])
                                : _vm._e(),
                              _vm.flowType == "cabundle"
                                ? _c("span", [_vm._v("Condo")])
                                : _vm._e(),
                              _vm.flowType == "rabundle"
                                ? _c("span", [_vm._v("Renters")])
                                : _vm._e(),
                              _vm._v(" Coverage to create a bundle")
                            ])
                          : _c(
                              "div",
                              { staticClass: "selected-home-carrier" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "bundle-carrier-logo" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          _vm.selectedHomeCarrier.logoPathSvg,
                                        alt:
                                          _vm.selectedHomeCarrier.carrier_name
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "bundle-coverage-text ml-2 pl-2"
                                      },
                                      [
                                        _vm.flowType == "bundle"
                                          ? _c("span", [_vm._v("Home")])
                                          : _vm._e(),
                                        _vm.flowType == "cabundle"
                                          ? _c("span", [_vm._v("Condo")])
                                          : _vm._e(),
                                        _vm.flowType == "rabundle"
                                          ? _c("span", [_vm._v("Renters")])
                                          : _vm._e(),
                                        _vm._v(" Coverage")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.policyTerm === "m" &&
                                _vm.selectedHomeCarrier.monthly_premium !== null
                                  ? _c(
                                      "div",
                                      { staticClass: "bundle-carrier-premium" },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("currency-filter")(
                                                _vm.selectedHomeCarrier
                                                  .monthly_premium
                                              )
                                            ) + " "
                                          ),
                                          _c("span", [_vm._v("/Month")])
                                        ])
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.selectedHomeCarrier
                                                .premium_amount !== null,
                                            expression:
                                              "selectedHomeCarrier.premium_amount !== null"
                                          }
                                        ],
                                        staticClass:
                                          "bundle-carrier-premium discounted"
                                      },
                                      [
                                        _c("div", [
                                          _c("span", { staticClass: "save" }, [
                                            _vm._v(
                                              "Save " +
                                                _vm._s(
                                                  _vm._f("currency-filter")(
                                                    _vm.selectedHomeCarrier
                                                      .payinfull_discount
                                                  )
                                                )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "line-through" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency-filter")(
                                                    _vm.selectedHomeCarrier
                                                      .premium_amount
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("currency-filter")(
                                                  _vm.selectedHomeCarrier
                                                    .payinfull_amount
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "quoteTerm" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "text-capitalize"
                                                },
                                                [_vm._v("Full")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedHomeCarrier
                                                      .policy_term
                                                  )
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                              ]
                            )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 text-center",
                        class: { "disabled bound-carrier": _vm.isAutoBound }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row align-items-center no-gutters" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-11" }, [
                              !_vm.selectedAutoCarrier
                                ? _c(
                                    "div",
                                    { staticClass: "select-auto-carrier" },
                                    [
                                      _vm._v(
                                        "Select Auto Coverage to create a bundle"
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "selected-auto-carrier" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "bundle-carrier-logo" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                _vm.selectedAutoCarrier
                                                  .logoPathSvg,
                                              alt:
                                                _vm.selectedAutoCarrier
                                                  .carrier_name
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bundle-coverage-text ml-2 pl-2"
                                            },
                                            [_vm._v("Auto Coverage")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.policyTerm === "m" &&
                                      _vm.selectedAutoCarrier
                                        .monthly_premium !== null
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bundle-carrier-premium"
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency-filter")(
                                                      _vm.selectedAutoCarrier
                                                        .monthly_premium
                                                    )
                                                  ) + "  "
                                                ),
                                                _c("span", [_vm._v("/Month")])
                                              ])
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.selectedAutoCarrier
                                                      .premium_amount !== null,
                                                  expression:
                                                    "selectedAutoCarrier.premium_amount !== null"
                                                }
                                              ],
                                              staticClass:
                                                "bundle-carrier-premium discounted"
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  { staticClass: "save" },
                                                  [
                                                    _vm._v(
                                                      "Save " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "currency-filter"
                                                          )(
                                                            _vm
                                                              .selectedAutoCarrier
                                                              .payinfull_discount
                                                          )
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "line-through"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "currency-filter"
                                                        )(
                                                          _vm
                                                            .selectedAutoCarrier
                                                            .premium_amount
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("currency-filter")(
                                                        _vm.selectedAutoCarrier
                                                          .payinfull_amount
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "quoteTerm" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-capitalize"
                                                      },
                                                      [_vm._v("Full")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm
                                                            .selectedAutoCarrier
                                                            .policy_term
                                                        )
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                    ]
                                  )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-3 px-1 my-auto text-center" },
                      [
                        _vm.policyTerm === "m"
                          ? _c(
                              "div",
                              { staticClass: "bundle-carrier-premium total" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm._f("currency-filter")(
                                        _vm.calculateBundlePremiumAmount
                                      )
                                    )
                                ),
                                _c("span", { staticClass: "quoteTerm" }, [
                                  _vm._v("/Month")
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "bundle-carrier-premium discounted"
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency-filter")(
                                        _vm.calculateBundlePremiumAmount
                                      )
                                    ) + "\n            "
                                  ),
                                  _vm.selectedHomeCarrier &&
                                  _vm.selectedAutoCarrier
                                    ? _c("span", { staticClass: "quoteTerm" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectedHomeCarrier
                                                .policy_term
                                            )
                                        )
                                      ])
                                    : _vm.selectedHomeCarrier
                                    ? _c("span", { staticClass: "quoteTerm" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectedHomeCarrier
                                                .policy_term
                                            )
                                        )
                                      ])
                                    : _vm.selectedAutoCarrier
                                    ? _c("span", { staticClass: "quoteTerm" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectedAutoCarrier
                                                .policy_term
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "save align-top" },
                                    [
                                      _vm._v(
                                        "Save " +
                                          _vm._s(
                                            _vm._f("currency-filter")(
                                              _vm.calculateBundleDiscount
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                        _vm._v(" "),
                        _c("div", { staticClass: "button-row" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary select-carrier-btn mb-2",
                              attrs: {
                                type: "button",
                                tabindex: "0",
                                id: "select-carrier-btn",
                                role: "button"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openRc2Flow()
                                }
                              }
                            },
                            [_vm._v("Save & Continue")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c(
        "div",
        { staticClass: "col-12 py-2 bg-greyed text-white rounded-top" },
        [
          _c("strong", [_vm._v("Carrier Knockouts")]),
          _vm._v(" "),
          _c("div", { staticClass: "smaller-font-content" }, [
            _vm._v(
              "The following carrier(s) were unable to return a quote with the provided customer information."
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", { staticClass: "icon-star" }, [_vm._v("*")]),
      _vm._v(" Payment options will be finalized at checkout")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1" }, [
      _c("i", { staticClass: "fa fa-plus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9adb8f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9adb8f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/CarrierMatches.vue
// module id = null
// module chunks = 